import { lazy, Suspense } from "react";
import { BrowserRouter, Link, Route, Routes } from "react-router-dom";
import { Notice } from "./components/Cards";
import { Layout } from "./components/Layout";
import { BrowsePage, SearchPage } from "./pages/Browse";
import { HomePage } from "./pages/Home";
import { LoginPage } from "./pages/Login";
import { TitlePage } from "./pages/TitlePage";
import { CatalogProvider, useCatalog } from "./state/CatalogContext";

// El reproductor (Shaka, JASSUB) se carga solo al reproducir.
const WatchPage = lazy(() => import("./pages/Watch").then((m) => ({ default: m.WatchPage })));
const ChannelsPage = lazy(() => import("./pages/Channels").then((m) => ({ default: m.ChannelsPage })));
const ChannelWatchPage = lazy(() => import("./pages/Channels").then((m) => ({ default: m.ChannelWatchPage })));
const IptvWatchPage = lazy(() => import("./pages/Channels").then((m) => ({ default: m.IptvWatchPage })));

function Loading() {
  return <div className="grid min-h-screen place-items-center"><div className="spinner" aria-label="Cargando" /></div>;
}

function Gate() {
  const { session, catalog, error, loading, refresh } = useCatalog();
  if (session && !session.configured && !session.public && session.missing.length) {
    return (
      <Notice title="Radiant TV aún no está configurado">
        Faltan variables en Cloudflare Pages: {session.missing.join(", ")}. Consulta docs/DEPLOY.md.
      </Notice>
    );
  }
  if (session && !session.authenticated) return <LoginPage />;
  if (loading && !catalog) return <Loading />;
  if (!catalog) {
    return (
      <Notice title="No se pudo cargar tu biblioteca" action={<button className="btn" onClick={() => void refresh()}>Reintentar</button>}>
        {error?.message ?? "Error desconocido."}
      </Notice>
    );
  }
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/ver/:id/:episodeId?" element={<WatchPage />} />
        <Route path="/canales/:id" element={<ChannelWatchPage />} />
        <Route path="/directo/:id" element={<IptvWatchPage />} />
        <Route path="*" element={
          <Layout>
            <Routes>
              <Route index element={<HomePage />} />
              <Route path="peliculas" element={<BrowsePage key="movie" category="movie" />} />
              <Route path="series" element={<BrowsePage key="series" category="series" />} />
              <Route path="anime" element={<BrowsePage key="anime" category="anime" />} />
              <Route path="buscar" element={<SearchPage />} />
              <Route path="titulo/:id" element={<TitlePage />} />
              <Route path="canales" element={<ChannelsPage />} />
              <Route path="*" element={<Notice title="Página no encontrada" action={<Link className="btn" to="/">Ir al inicio</Link>}>La dirección no existe.</Notice>} />
            </Routes>
          </Layout>
        } />
      </Routes>
    </Suspense>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <CatalogProvider>
        <Gate />
      </CatalogProvider>
    </BrowserRouter>
  );
}
